<template>
  <div
    v-clickoutside="close"
    class="header-user-menu"
    @keydown.esc="closeAndFocusTrigger"
  >
    <button
      ref="trigger"
      type="button"
      class="header-user-menu__trigger"
      :class="{ 'is-open': isOpen }"
      :aria-expanded="isOpen ? 'true' : 'false'"
      :aria-controls="isOpen ? panelId : null"
      @click="toggle"
    >
      <user-avatar :name="name" aria-hidden="true" />
      <span class="header-user-menu__identity">
        <span class="header-user-menu__first-name">{{ firstName }}</span>
        <span class="header-user-menu__profile">{{ profileLabel }}</span>
      </span>
      <lucide-icon
        :icon="icons.chevronDown"
        :size="16"
        class="header-user-menu__chevron"
        aria-hidden="true"
      />
    </button>

    <transition name="header-user-menu-panel">
      <div
        v-if="isOpen"
        :id="panelId"
        role="region"
        :aria-label="$t('menuusuario')"
        class="header-user-menu__panel"
        :style="panelStyle"
      >
        <div class="header-user-menu__header">
          <p class="header-user-menu__name">{{ name }}</p>
          <p class="header-user-menu__header-profile">{{ profileLabel }}</p>
        </div>

        <div class="header-user-menu__section">
          <button
            type="button"
            class="header-user-menu__option"
            @click="openLanguageModal"
          >
            <lucide-icon
              :icon="icons.globe"
              :size="16"
              class="header-user-menu__option-icon"
              aria-hidden="true"
            />
            <span class="header-user-menu__option-label">{{
              $t('idioma')
            }}</span>
            <span class="header-user-menu__option-value">{{
              currentLocale
            }}</span>
            <lucide-icon
              :icon="icons.chevronRight"
              :size="16"
              class="header-user-menu__option-icon"
              aria-hidden="true"
            />
          </button>
        </div>

        <div class="header-user-menu__section">
          <button
            type="button"
            class="header-user-menu__logout"
            @click="handleLogout"
          >
            <lucide-icon :icon="icons.logOut" :size="16" aria-hidden="true" />
            {{ $t('sair') }}
          </button>
        </div>
      </div>
    </transition>

    <language-settings-modal
      :open.sync="isLanguageModalOpen"
      :current-locale="currentLocale"
      :options="availableLocales"
      @confirm="changeLocale"
    />
  </div>
</template>

<script>
import { ChevronDown, ChevronRight, Globe, LogOut } from 'lucide'
import Clickoutside from 'element-ui/lib/utils/clickoutside'
import LucideIcon from '@/components/LucideIcon'
import UserMenu from '@/layout/mixin/UserMenu'
import UserAvatar from './UserAvatar'
import LanguageSettingsModal from './LanguageSettingsModal'

const PANEL_OFFSET = 8

export default {
  name: 'HeaderUserMenu',
  components: { LucideIcon, UserAvatar, LanguageSettingsModal },
  directives: { Clickoutside },
  mixins: [UserMenu],
  data() {
    return {
      isOpen: false,
      isLanguageModalOpen: false,
      panelStyle: {}
    }
  },
  computed: {
    panelId() {
      return `header-user-menu-${this._uid}`
    },
    icons() {
      return {
        chevronDown: ChevronDown,
        chevronRight: ChevronRight,
        globe: Globe,
        logOut: LogOut
      }
    }
  },
  methods: {
    open() {
      const { right, bottom } = this.$el.getBoundingClientRect()
      this.panelStyle = {
        top: `${bottom + PANEL_OFFSET}px`,
        right: `${document.documentElement.clientWidth - right}px`
      }
      this.isOpen = true
    },
    close() {
      this.isOpen = false
    },
    toggle() {
      if (this.isOpen) this.close()
      else this.open()
    },
    closeAndFocusTrigger() {
      this.close()
      this.$refs.trigger.focus()
    },
    openLanguageModal() {
      this.closeAndFocusTrigger()
      this.isLanguageModalOpen = true
    },
    handleLogout() {
      this.close()
      this.logout()
    }
  }
}
</script>
